import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const links = [
  { label: "El Problema", href: "#problema" },
  { label: "Cómo funciona", href: "#como-funciona" },
  { label: "Funcionalidades", href: "#funcionalidades" },
  { label: "Precios", href: "#precios" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <header
      data-testid={LANDING.navbar}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/80 border-b border-gray-200/60 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="#" data-testid={LANDING.logo} className="flex items-center gap-1">
          <span className="font-['Outfit'] text-lg font-700 text-gray-900 tracking-tight">
            artificial
          </span>
          <span className="font-['Outfit'] text-lg font-700 text-[#38BDF8] tracking-tight">
            mente
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#38BDF8] ml-0.5 mt-1"></span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#precios"
          className="hidden md:inline-flex items-center gap-2 bg-[#38BDF8] hover:bg-[#0EA5E9] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors"
        >
          Ver propuesta
        </a>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden p-2 rounded-md text-gray-700"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gray-200 px-6 py-4 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-sky-500 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#precios"
            onClick={() => setMenuOpen(false)}
            className="block bg-[#38BDF8] text-white text-sm font-semibold px-5 py-2.5 rounded-lg text-center transition-colors"
          >
            Ver propuesta
          </a>
        </div>
      )}
    </header>
  );
}
